import * as THREE from "three";

export class Camera {
  constructor(store) {
    this.store = store;
    const aspect = window.innerWidth / window.innerHeight;
    const isMobile = window.innerWidth < 1200;
    this.camera = new THREE.PerspectiveCamera(isMobile ? 75 : 60, aspect, 0.1, 1000);
    this.defaultPosition = isMobile ? new THREE.Vector3(0, 8, 10) : new THREE.Vector3(0, 12, 12);
    this.defaultLookAt = new THREE.Vector3(0, 0, 0);
    this.targetPosition = this.defaultPosition.clone();
    this.targetLookAt = this.defaultLookAt.clone();
    this.camera.position.copy(this.defaultPosition);
    this.animationSpeed = 0.08;
    this.currentRotation = 0;
    this.targetRotation = 0;
    this.currentOffset = new THREE.Vector3(0, 12, 12);
    this.targetOffset = this.currentOffset.clone();
    this.isAnimating = false;
    this.handleResize();   
  }

  get() {return this.camera;}

  setPosition(isMobile) {
    if (isMobile) {this.camera.position.set(0, 8, 12); 
    } else {this.camera.position.set(0, 12, 12);}
    this.camera.lookAt(0, 0, 0);
   }

  handleResize() {
    window.addEventListener("resize", () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const isMobile = w < 768;
      this.camera.aspect = w / h;
      this.camera.fov = isMobile ? 75 : 60;
      this.setPosition(isMobile);
      this.camera.updateProjectionMatrix();
    });
  }


  update() {
    if (this.isAnimating) {
      this.store.enviroment.controls.target.lerp(this.targetLookAt, this.animationSpeed);
      this.currentRotation = THREE.MathUtils.lerp(this.currentRotation, this.targetRotation, this.animationSpeed);
      this.currentOffset.lerp(this.targetOffset, this.animationSpeed);
      const offset = this.currentOffset.clone();
      offset.applyAxisAngle(new THREE.Vector3(0, 1, 0), this.currentRotation);
      const rotatedPosition = this.targetLookAt.clone().add(offset);
      this.camera.position.lerp(rotatedPosition, this.animationSpeed);
      this.store.enviroment.controls.update();
      const posDone = this.camera.position.distanceTo(rotatedPosition) < 0.01;
      const targetDone = this.store.enviroment.controls.target.distanceTo(this.targetLookAt) < 0.01;
      const rotDone = Math.abs(this.currentRotation - this.targetRotation) < 0.01;
      if (posDone && targetDone && rotDone) {
        this.isAnimating = false;
        this.store.enviroment.controls.enabled = true;
      }
      } else {this.store.enviroment.controls.update();}
    }

  focus(position) {
    this.isAnimating = true;
    this.store.enviroment.controls.enabled = false;
    this.targetLookAt.copy(position);
    const radiusX = this.store.level.spawnRadiusX;
    const radiusY = this.store.level.spawnRadiusY;
    // Az ellipszist biztosan tartalmazó kör sugara
    const radius = Math.sqrt(radiusX * radiusX + radiusY * radiusY);
    // Kamera függőleges látószöge
    const fov = THREE.MathUtils.degToRad(this.camera.fov);
    // Szükséges távolság
    const distance = radius / Math.tan(fov / 2);
    // kis ráhagyás
    const padding = 2;
    this.targetOffset.set(-2, 8, distance * padding);
    const deg = this.store.config.isSmall ? 20 + Math.random() * 20 : 10 + Math.random() * 20
    const sign = Math.random() > 0.5 ? 1 : -1;
    this.targetRotation = THREE.MathUtils.degToRad(deg * sign);
  }

  focusCenter() {
    this.isAnimating = true;
    this.store.enviroment.controls.enabled = false;
    this.targetOffset.set(6, 4, 18);
  }

  reset() {   
    this.isAnimating = true;
    this.store.enviroment.controls.enabled = false;
    this.targetLookAt.copy(this.defaultLookAt);
    this.targetOffset.copy(this.defaultPosition);
    this.targetRotation = 0;
  }
}
